const AT = require("./ActionTypes");
const IdleInput = require("./util/IdleInput");

const makeClockForVault = function(vault) {
	// Setup IdleInput.
	IdleInput.start();
	IdleInput.listenToStatus(status => {
		if (status === "active") {
			vault.dispatch({type: AT.END_IDLE_OR_BLUR});
		} else {
			vault.dispatch({type: AT.START_IDLE_OR_BLUR, isIdle: status === "idle"});
		}
	});
	IdleInput.listenToSleep(lastInputTime => {
		vault.dispatch({type: AT.NOTIFY_SLEEP, lastInputTime});
	});

	let suppressingInterval = null;

	let freezedNow = -1;
	const now = () => (freezedNow === -1 ? Date.now() : freezedNow);
	return {
		now,
		freezeNow: () => {
			freezedNow = Date.now();
		},
		unfreezeNow: () => {
			freezedNow = -1;
		},
		getIdleDuration: IdleInput.getIdleDuration,
		setIdleDuration: IdleInput.setIdleDuration,
		getActiveSince: t => IdleInput.getActiveBetween(t, now()),
		setIdleSuppression: newValue => {
			if (suppressingInterval && !newValue) {
				clearInterval(suppressingInterval);
				suppressingInterval = null;
			} else if (!suppressingInterval && newValue) {
				suppressingInterval = setInterval(
					() => IdleInput.resetIdleTimeout(),
					1000
				);
			}
		},
		// Used to detect huge, incorrect increments to timers. Set to a number
		// higher than any idle duration. See OpsTimer.updateIfPastIdle for the
		// mechanism we use to avoid false positive increments larger than this.
		getMaxIncrement: () => 3600000, // 3600000 = 1 hour
	};
};

module.exports = {
	makeClockForVault,
};
